var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
// AB#333576 - componente de máscara dinâmica CPF/CNPJ alfanumérico - RN12 + RN13 + RN15 + RN19
import React from 'react';
import { IMaskInput } from 'react-imask';
var CPF_MASK = '000.000.000-00';
var CNPJ_MASK = 'aa.aaa.aaa/aaaa-00';
export var MascaraDocumento = React.forwardRef(function MascaraDocumentoInner(props, ref) {
    var onChange = props.onChange, tipoEsperado = props.tipoEsperado, other = __rest(props, ["onChange", "tipoEsperado"]);
    var commonProps = __assign(__assign({}, other), { prepareChar: function (ch) { return ch.toUpperCase(); }, inputRef: ref, onAccept: function (value) { return onChange({ target: { name: props.name, value: value } }); }, overwrite: true });
    if (tipoEsperado === 'cpf') {
        return _jsx(IMaskInput, __assign({}, commonProps, { mask: CPF_MASK }));
    }
    if (tipoEsperado === 'cnpj') {
        return (_jsx(IMaskInput, __assign({}, commonProps, { mask: CNPJ_MASK, definitions: { a: /[0-9A-Za-z]/ } })));
    }
    return (_jsx(IMaskInput, __assign({}, commonProps, { mask: [
            { mask: CPF_MASK },
            { mask: CNPJ_MASK, definitions: { a: /[0-9A-Za-z]/ } },
        ], dispatch: function (appended, dynamicMasked) {
            var merged = (dynamicMasked.value + appended).replace(/[^0-9A-Za-z]/g, '');
            var hasLetter = /[A-Za-z]/.test(merged);
            return hasLetter || merged.length > 11
                ? dynamicMasked.compiledMasks[1]
                : dynamicMasked.compiledMasks[0];
        } })));
});
export default MascaraDocumento;
